import { render, staticRenderFns } from "./HuchaListadoItem.vue?vue&type=template&id=70a9daa2&scoped=true"
import script from "./HuchaListadoItem.vue?vue&type=script&lang=js"
export * from "./HuchaListadoItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70a9daa2",
  null
  
)

export default component.exports